import React from "react";
import ReactDOM from "react-dom/client";
import "./stil/grundlagen.css";
import "./stil/bausteine.css";
import "./stil/dokument.css";
import "./stil/chat.css";
import "./stil/ipad.css";
import "./stil/dashboard.css";
import "./stil/anmelden.css";
import App from "./App";

const wurzel = ReactDOM.createRoot(document.getElementById("root"));
wurzel.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
